module.exports = __webpack_public_path__ + "static/img/2.6eb682d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/eng/2.png
// module id = 5YZM
// module chunks = 0